import { css, cx } from '@linaria/core';
import { baseUnits, flex, theming } from 'styles/utils';
export const wrapper = "omponents__BoxLoader__BoxLoader_styles_ts-wrapper-w4qota9";
export const loaderWrapper = cx(wrapper, flex.init, flex.alignItems.center, flex.justifyContent.between);

require("./BoxLoader.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./BoxLoader.styles.ts");